import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import PwaInstallPrompt from "@/components/PwaInstallPrompt";
import ErrorBoundary from "@/components/ErrorBoundary";
import LoginPage from "@/pages/LoginPage";
import Layout from "@/pages/Layout";
import DashboardPage from "@/pages/DashboardPage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import ProductFormPage from "@/pages/ProductFormPage";
import CaricoPage from "@/pages/CaricoPage";
import InvoiceImportPage from "@/pages/InvoiceImportPage";
import ScaricoPage from "@/pages/ScaricoPage";
import ScaricoMobilePage from "@/pages/ScaricoMobilePage";
import ReportsPage from "@/pages/ReportsPage";
import OfficineMobiliPage from "@/pages/OfficineMobiliPage";
import CustomersPage from "@/pages/CustomersPage";
import MachinesPage from "@/pages/MachinesPage";
import MachineHistoryPage from "@/pages/MachineHistoryPage";
import WorkOrdersPage from "@/pages/WorkOrdersPage";
import WorkOrderDetailPage from "@/pages/WorkOrderDetailPage";
import CalendarPage from "@/pages/CalendarPage";
import SmontaggiPage from "@/pages/SmontaggiPage";
import MovementsPage from "@/pages/MovementsPage";
import LabelsPage from "@/pages/LabelsPage";
import UsersPage from "@/pages/UsersPage";
import ScannerPage from "@/pages/ScannerPage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <div className="text-[#4CAF50] font-display uppercase tracking-widest text-sm">Caricamento...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<Protected><Layout /></Protected>}>
        <Route index element={<DashboardPage />} />
        <Route path="prodotti" element={<ProductsPage />} />
        <Route path="prodotti/nuovo" element={<ProductFormPage />} />
        <Route path="prodotti/:id" element={<ProductDetailPage />} />
        <Route path="prodotti/:id/modifica" element={<ProductFormPage />} />
        <Route path="carico" element={<CaricoPage />} />
        <Route path="carico-pdf" element={<InvoiceImportPage />} />
        <Route path="scarico" element={<ScaricoPage />} />
        <Route path="scarico-mobile" element={<ScaricoMobilePage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="officine-mobili" element={<OfficineMobiliPage />} />
        <Route path="clienti" element={<CustomersPage />} />
        <Route path="macchine" element={<MachinesPage />} />
        <Route path="macchine/:id/storico" element={<MachineHistoryPage />} />
        <Route path="schede" element={<WorkOrdersPage />} />
        <Route path="schede/:id" element={<WorkOrderDetailPage />} />
        <Route path="calendario" element={<CalendarPage />} />
        <Route path="smontaggi" element={<SmontaggiPage />} />
        <Route path="movimenti" element={<MovementsPage />} />
        <Route path="etichette" element={<LabelsPage />} />
        <Route path="scanner" element={<ScannerPage />} />
        <Route path="utenti" element={<UsersPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  useEffect(() => {
    // Silenzia UnavailableError e altri errori camera html5-qrcode che escapano come unhandled rejection
    const onRejection = (e) => {
      const msg = String(e?.reason?.message || e?.reason || "");
      if (/NotAllowedError|NotFoundError|UnavailableError|getUserMedia|html5-qrcode|camera/i.test(msg)) {
        e.preventDefault();
        console.warn("[app] swallowed camera-related rejection:", msg);
      }
    };
    window.addEventListener("unhandledrejection", onRejection);
    return () => window.removeEventListener("unhandledrejection", onRejection);
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ErrorBoundary>
            <AppRoutes />
          </ErrorBoundary>
          <Toaster theme="dark" position="top-right" />
          <PwaInstallPrompt />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
